import gql from 'graphql-tag';

export const ME_FOR_POINT = gql`
  query meForPoint($first: Int, $after: String) {
    me {
      id
      pointEvents(first: $first, after: $after) {
        totalCount
        pageInfo {
          startCursor
        }
        edges {
          node {
            id
            amount
            type
            createdAt
            expiringDate
            description
          }
        }
      }
      point {
        id
        availableAmount
        usedAmount
        earnedAmount
        expiredAmount
      }
    }
  }
`;
